export type ErrorVariant = 'error' | 'info' | 'success' | 'warning' | 'default';

export type ErrorDetails = {
    token: string;
    variant: ErrorVariant;
};

export type ErrorType = {
    error?: string;
    message?: string;
};

export const ERROR_MESSAGES = {
    access_denied: 'person.import.contacts.access.denied',
    scope_not_granted: 'person.import.contacts.scope.failed',
    no_contacts_found: 'person.import.contacts.response.none',
    unknown_error: 'import.unknownerror.common.label'
} as const;

export const ERROR_VARIANTS: Record<string, ErrorDetails> = {
    access_denied: { token: ERROR_MESSAGES.access_denied, variant: 'error' },
    scope_not_granted: { token: ERROR_MESSAGES.scope_not_granted, variant: 'error' },
    no_contacts_found: { token: ERROR_MESSAGES.no_contacts_found, variant: 'info' },
    unknown_error: { token: ERROR_MESSAGES.unknown_error, variant: 'error' }
};

export const getErrorMessage = (error: ErrorType): ErrorDetails | null => {
    const errorMessage = error.error || error.message;
    return ERROR_VARIANTS[errorMessage || ''] || null;
};
